<template>
  <v-container grid-list-md pa-0 class='playlist'>
    <transition name='fade'>
      <div
        class='playlist-header mb-5'
        v-if='playlist.internalImageLarge'
        :style="'background: url('+playlist.internalImageLarge+') no-repeat 50% 50%'"
      ></div>
    </transition>
    <v-layout row ma-2 pa-4 pt-0 wrap>
      <v-flex xs12 mb-4>
        <h1 class='display-1'>
          <b>{{ playlist.description }}</b>
        </h1>
      </v-flex>

      <transition-group name='fade' tag='v-layout' class='xs12 row wrap'>
        <card-issue
          v-for='item in issues'
          :key='`slide-playlist-${item.id}`'
          :id='item.id'
          :issue='item'
          :isFree='item.isFree'
          :img='item.cover'
          :title='item.title.name'
          :subtitle="'Volume ' + item.number"
        ></card-issue>
      </transition-group>

      <transition name='fade'>
        <v-flex xs12 mb-4 v-if='loaded == true && issues.length == 0'>
          <v-alert :value='true' type='warning'>Playlist não encontrada ou indisponível no momento.</v-alert>
        </v-flex>
      </transition>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';
import bus from '@/utils/bus';
import loading from '@/components/Loading';
import cardIssue from '@/components/cardIssue';

export default {
  name: 'playlist',
  components: {
    loading,
    'card-issue': cardIssue
  },
  metaInfo() {
    return {
      title: this.$route.meta.title
        ? 'E-Komics - ' + this.$t(this.$route.meta.title)
        : 'E-Komics'
    };
  },
  data() {
    return {
      loaded: false,
      errors: [],
      issues: [],
      playlist: {}
    };
  },
  mounted() {
    bus.$emit('loading', true);
    if (this.$route.meta.type === 'Popular') {
      this.getPopular();
    } else if (this.$route.meta.type === 'Recomended') {
      this.getRecommended();
    } else if (this.$route.meta.type === 'News') {
      this.getNews();
    } else {
      this.getPlaylist();
    }
  },
  methods: {
    getPlaylist() {
      // console.log('PlaylistID -> ', this.$route.params.playlistId);
      axios
        .get('/playlists/' + this.$route.params.playlistId)
        .then(response => {
          // console.info(response.data)
          this.issues = response.data.issues;
          this.loaded = true;
          bus.$emit('loading', false);
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
        })
        .catch(e => {
          // console.error(e)
          this.errors.push(e);
          this.loaded = true;
          bus.$emit('loading', false);
        });
    },

    getPopular() {
      axios
        .get('/issues/weeklyTop', {
          params: {
            limit: 30,
            page: 1
          }
        })
        .then(response => {
          // console.info(response.data)
          this.issues = response.data.results;
          this.loaded = true;
          bus.$emit('loading', false);
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
        })
        .catch(e => {
          // console.error(e)
          this.errors.push(e);
          this.loaded = true;
          bus.$emit('loading', false);
        });
    },

    getRecommended() {
      axios
        .get('/issues/recommended', {
          params: {
            limit: 30,
            page: 1
          }
        })
        .then(response => {
          this.issues = response.data.results;
          this.loaded = true;
          bus.$emit('loading', false);
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
        })
        .catch(e => {
          console.error(e);
          this.errors.push(e);
          this.loaded = true;
          bus.$emit('loading', false);
        });
    },

    getNews() {
      axios
        .get('/issues/news', {
          params: {
            limit: 30,
            page: 1
          }
        })
        .then(response => {
          this.issues = response.data.results;
          this.loaded = true;
          bus.$emit('loading', false);
          this.$store.commit(
            'setSubscription',
            response.headers['active-subscription']
          );
        })
        .catch(e => {
          console.error(e);
          this.errors.push(e);
          this.loaded = true;
          bus.$emit('loading', false);
        });
    }
  }
};
</script>

<style lang='scss'>
@import '../assets/css/_variables';

.playlist {
  &-header {
    height: auto;
    overflow: hidden;
    width: 100%;
    background-size: contain !important;
    padding-bottom: 53%;
  }
}
</style>
